export default {
  namespaced: true,
  state: {
    searchData: {
      keyword: "",
      type: "", //1：关键字，2：vin码，-1:高级查询,-2:不带任何条件的查询
      historyId: 0,
      historyType: "",
      fromHistory: false
    }
  },
  getters: {
    getSearchData: state => {
      return state.searchData;
    }
  },
  mutations: {
    /**
     * 与 master 一致：整份覆盖，不以旧 searchData 为底。
     * 首页关键字查件后再从首页点配件区进列表时，入参通常不带 keyword，
     * 若 merge 旧状态会把上次关键字带进本次查询。
     * history* 给默认值，调用方未传时不影响历史查件以外的入口。
     */
    setSearchData(state, searchData) {
      state.searchData = {
        keyword: "",
        type: "",
        historyId: 0,
        historyType: "",
        fromHistory: false,
        ...(searchData || {})
      };
    }
  }
};
